var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class FieldTransformation {
  constructor(_data) {
    /**
     */
    __publicField(this, "FallbackSources");
    /**
     */
    __publicField(this, "Source");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof FieldTransformation
     */
    __publicField(this, "$type", "V1.GenerationConfiguration.FieldTransformation");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["FallbackSources"] && _data["FallbackSources"].constructor === Array) {
        this.FallbackSources = [];
        for (let item of _data["FallbackSources"]) {
          this.FallbackSources.push(item);
        }
      }
      this.Source = _data["Source"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["$type"] = this.$type;
    if (this.FallbackSources && this.FallbackSources.constructor === Array) {
      _data["FallbackSources"] = [];
      for (let item of this.FallbackSources) {
        _data["FallbackSources"].push(item);
      }
    }
    _data["Source"] = this.Source;
    return _data;
  }
}
